module.exports = __webpack_public_path__ + "img/ufo-art-03_small.fbc17d79.webp";